import { BrandMark, Button, MobileIntro } from '@relay-towing/ui';
import { useNavigate } from 'react-router-dom';
import { useSignIn } from '../../hooks/useSignIn';
import { native } from '../../lib/nativeBridge';

/**
 * The first page a signed-out member sees, in a browser or a phone app:
 * what Relay is, then Sign in, Create account, or Google, and Apple in the
 * iPhone app, where the App Store asks for it beside Google. Signing in is
 * Auth0's page, which a phone app opens in its own sign-in sheet
 * (useSignIn); creating an account is the phone's own sign-up at /signup,
 * as the dashboard's is its own, since an account made on Auth0's page
 * would have no company.
 *
 * There is no Figma frame for it. It is drawn as the Welcome frame is
 * (123:7108): the brand, a centred title over a muted line, and the
 * answers held along the bottom as big pills with a quieter link under
 * them. A designer's frame replaces this when there is one.
 */
export function LandingScreen() {
  const navigate = useNavigate();
  const { signIn, signInWithGoogle, signInWithApple } = useSignIn();
  const offersApple = native()?.platform === 'ios';
  return (
    <MobileIntro
      brand={<BrandMark name="relay" size="xl" />}
      title="Run your towing business from your phone"
      description="Calls, trucks, impounds and invoices for your whole team, in one app."
      actions={
        <>
          <Button size="xl" pill variant="soft" onClick={() => void signIn()}>
            Sign in
          </Button>
          <Button
            size="xl"
            pill
            variant="outline"
            onClick={() => navigate('/signup')}
          >
            Create account
          </Button>
          {offersApple && (
            <Button variant="link" onClick={() => void signInWithApple()}>
              Continue with Apple
            </Button>
          )}
          <Button variant="link" onClick={() => void signInWithGoogle()}>
            Continue with Google
          </Button>
        </>
      }
    />
  );
}
